import React, { useEffect } from 'react';
import { Query } from 'react-apollo';
import moment from 'moment';

import { OrganizerQuery } from '../../state/services/gql/organizer';
import organizerResolver from '../../state/resolvers/organiser';

import { trackPageVisit, PAGE_NAME } from '../../utils/tracking';
import getSearchQueryParams from '../../utils/getSearchQueryParams';

// TODO(orange): loadable
import LoadableOrganiserDetailPage from '../../components/OrganiserDetailPage';

const getSearchQuery = (organiserId) => ({
  ...getSearchQueryParams({
    organiserId,
    // Exact date/timezone is required to match server/client requirest for ssr.
    minDate: moment.utc('2018-09-12T00:00:00.000Z'),
  }),
  resultsPerPage: 100,
});

const getOrganizerId = (props) => {
  const { routeParams } = props;
  return (
    routeParams &&
    routeParams.organiserId &&
    parseInt(routeParams.organiserId, 10)
  );
};

/**
 * Organiser detail page container.
 * Wraps the organiser detail page presentational component with Redux state.
 * Adds props to component representing fetch state and organiser object result.
 */
export function OrganiserDetailPageContainer(props) {
  const { error, route, router, location } = props;
  const rawOrganizerData = props?.data?.organizer;
  const organiser = organizerResolver(rawOrganizerData) || null; // adds client computated fields

  useEffect(() => {
    // If the error has a status code, overwrite the route
    if (error && error.status) {
      route.status = error.status;
    }
  }, []);

  // Push the organiser slug to the URL if it's absent
  useEffect(() => {
    if (!router?.params?.organiserSlug && organiser?.permalink) {
      router.replace(
        `${organiser.permalink}${location.search}${location.hash}`,
      );
    }
    if (organiser) {
      trackPageVisit(PAGE_NAME.ORGANISER_PAGE);
    }
    // this used the raw data from GQL as the resolver mutates the object causing re-rendering;
  }, [rawOrganizerData]);

  return (
    <LoadableOrganiserDetailPage
      {...props}
      organiser={organiser}
      searchQuery={getSearchQuery(getOrganizerId(props))}
    />
  );
}

OrganiserDetailPageContainer.propTypes = LoadableOrganiserDetailPage.propTypes;

const OrganizerDetailPageWithGraphQL = (props) => {
  const gqlParams = {
    organizerId: getOrganizerId(props),
  };

  return (
    <Query
      notifyOnNetworkStatusChange
      query={OrganizerQuery}
      variables={gqlParams}
      errorPolicy="all"
    >
      {(gqlData) => {
        return <OrganiserDetailPageContainer {...props} {...gqlData} />;
      }}
    </Query>
  );
};

export default OrganizerDetailPageWithGraphQL;
